import { render, staticRenderFns } from "./Period.vue?vue&type=template&id=19a7df16&scoped=true&"
import script from "@/views/Periods/Period.ts?vue&type=script&lang=ts&"
export * from "@/views/Periods/Period.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Periods/period.scss?vue&type=style&index=0&id=19a7df16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7df16",
  null
  
)

export default component.exports